import { format } from 'date-fns'

export const generateExcelFileName = (prefix: string) => {
  const now = new Date()

  const generationDate = format(now, 'ddMMyyyy')
  const generationTime = format(now, 'HHmmss')

  return `${prefix}_${generationDate}_${generationTime}.xlsx`
}
